import {getPromotionListingSlugByType} from "./promotion_listing_config";
import {PromotionType} from "./PromotionType";

export interface IFriendlyPromotionQuery {
    region?: string;
    regionParentSlug?: string;
    type?: PromotionType;
}

export interface IPromotionUrlRegion {
    parent?: {slug: string} | null;
    slug: string;
}

export const getPromotionSlugByType = (type?: PromotionType): string => {
    return getPromotionListingSlugByType(type);
};

export const formatPromotionRegionPathForUrl = (regionSlug: string, regionParentSlug?: string): string => {
    if (!regionSlug) {
        return "";
    }

    // Only nest into "parent/child" when the region slug actually contains the parent slug as a prefix
    // (e.g. district "warszawa-bialoleka" within city "warszawa"). For a city whose parent is a voivodeship
    // (e.g. "warszawa" within "mazowieckie") the parent must not become a URL segment.
    if (regionParentSlug && regionSlug.startsWith(`${regionParentSlug}-`)) {
        const childSlug = regionSlug.slice(regionParentSlug.length + 1);

        return `${regionParentSlug}/${childSlug}`;
    }

    return regionSlug;
};

export const buildFriendlyPromotionSlug = (data: Partial<IFriendlyPromotionQuery>): string => {
    const segments: string[] = [];
    const typeSlug = getPromotionSlugByType(data.type);

    if (typeSlug) {
        segments.push(typeSlug);
    }

    if (data.region) {
        segments.push(formatPromotionRegionPathForUrl(data.region, data.regionParentSlug));
    }

    return segments.join("/");
};

export const buildFriendlyPromotionSlugFromRegion = (data: {region?: IPromotionUrlRegion | null; type?: PromotionType}): string => {
    return buildFriendlyPromotionSlug({
        region: data.region?.slug,
        regionParentSlug: data.region?.parent?.slug,
        type: data.type
    });
};
import {getPromotionListingSlugByType} from "./promotion_listing_config";
import {PromotionType} from "./PromotionType";

export interface IFriendlyPromotionQuery {
    region?: string;
    regionParentSlug?: string;
    type?: PromotionType;
}

export interface IPromotionUrlRegion {
    parent?: {slug: string} | null;
    slug: string;
}

export const getPromotionSlugByType = (type?: PromotionType): string => {
    return getPromotionListingSlugByType(type);
};

export const formatPromotionRegionPathForUrl = (regionSlug: string, regionParentSlug?: string): string => {
    if (!regionSlug) {
        return "";
    }

    // Only nest into "parent/child" when the region slug actually contains the parent slug as a prefix
    // (e.g. district "warszawa-bialoleka" within city "warszawa"). For a city whose parent is a voivodeship
    // (e.g. "warszawa" within "mazowieckie") the parent must not become a URL segment.
    if (regionParentSlug && regionSlug.startsWith(`${regionParentSlug}-`)) {
        const childSlug = regionSlug.slice(regionParentSlug.length + 1);

        return `${regionParentSlug}/${childSlug}`;
    }

    return regionSlug;
};

export const buildFriendlyPromotionSlug = (data: Partial<IFriendlyPromotionQuery>): string => {
    const segments: string[] = [];
    const typeSlug = getPromotionSlugByType(data.type);

    if (typeSlug) {
        segments.push(typeSlug);
    }

    if (data.region) {
        segments.push(formatPromotionRegionPathForUrl(data.region, data.regionParentSlug));
    }

    return segments.join("/");
};

export const buildFriendlyPromotionSlugFromRegion = (data: {region?: IPromotionUrlRegion | null; type?: PromotionType}): string => {
    return buildFriendlyPromotionSlug({
        region: data.region?.slug,
        regionParentSlug: data.region?.parent?.slug,
        type: data.type
    });
};
